module.exports = __webpack_public_path__ + "img/wz-8-7-2.6104eb31.jpg";